module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"maybe-has-an-open-dialog":"Möglicherweise hat diese Sektion noch einen offenen Dialog"},"fr":{"maybe-has-an-open-dialog":"Il est possible que cette section ait encore un dialogue ouvert"},"it":{"maybe-has-an-open-dialog":"Questa sezione potrebbe avere ancora una finestra di dialogo aperto"}}')
  delete Component.options._Ctor
}
